import {createContext as $cdnFz$createContext, useContext as $cdnFz$useContext, useEffect as $cdnFz$useEffect} from "react";
import $cdnFz$macrostrathyper from "@macrostrat/hyper";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $5dad98c488232470$exports = {};

$parcel$export($5dad98c488232470$exports, "PhotoLibraryContext", () => $5dad98c488232470$export$9f4be09e3914797a);
$parcel$export($5dad98c488232470$exports, "PhotoLibraryProvider", () => $5dad98c488232470$export$77971d5b6cbacaf9);
$parcel$export($5dad98c488232470$exports, "PhotoOverlay", () => $5dad98c488232470$export$24f17aabaa7629ce);


// Default value for computePhotoPath
const $5dad98c488232470$var$passThrough = (src)=>src;
const $5dad98c488232470$export$9f4be09e3914797a = (0, $cdnFz$createContext)({
    photos: null,
    computePhotoPath: $5dad98c488232470$var$passThrough
});
function $5dad98c488232470$export$77971d5b6cbacaf9(props) {
    const { children: children, computePhotoPath: computePhotoPath = $5dad98c488232470$var$passThrough, photos: photos } = props;
    return (0, $cdnFz$macrostrathyper)($5dad98c488232470$export$9f4be09e3914797a.Provider, {
        value: {
            photos: photos,
            computePhotoPath: computePhotoPath
        },
        children: children
    });
}
function $5dad98c488232470$export$24f17aabaa7629ce(props) {
    const { photos: photos, computePhotoPath: computePhotoPath } = (0, $cdnFz$useContext)($5dad98c488232470$export$9f4be09e3914797a);
    if (photos == null) return null;
    const { photoIDs: photoIDs, ...rest } = props;
    const displayedPhotos = photoIDs.map((id)=>{
        return photos.find((d)=>d.id === id);
    });
    const getPaths = function(d) {
        const src = computePhotoPath(d);
        return {
            src: src,
            caption: d.note
        };
    };
    const images = displayedPhotos.filter((d)=>d != null).map(getPaths);
    return (0, $cdnFz$macrostrathyper)($5dad98c488232470$var$PhotoGallery, {
        images: images,
        ...rest
    });
}
const $5dad98c488232470$var$PhotoGallery = function({ images: images, isOpen: isOpen = false, onClose: onClose }) {
    /** The photo gallery component  has been removed due to an outdated design.
   * Please use another library for this functionality.
   */ (0, $cdnFz$useEffect)(()=>{
        console.error("PhotoOverlay from @macrostrat/column-components has been disabled due to an outdated design. Please use another library for this functionality.");
    }, []);
    return null;
};


export {$5dad98c488232470$export$9f4be09e3914797a as PhotoLibraryContext, $5dad98c488232470$export$77971d5b6cbacaf9 as PhotoLibraryProvider, $5dad98c488232470$export$24f17aabaa7629ce as PhotoOverlay};
//# sourceMappingURL=column-components.177e6187.js.map
